const initialState = {
  userType: { label: "All", value: null },
};

const documentTabReducer = (state = initialState, action) => {
  switch (action.type) {
    case "documentTypeAction":
      state = { ...state, userType: action.payload };
      return state;
    default:
      return state;
  }
};
export default documentTabReducer;
